import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "medium",
    title: "Передача в отдел продаж",
    loading: _ctx.state.is_loading,
    onConfirm: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_textarea, {
        class: "mt-2",
        autoheight: "",
        disabled: _ctx.state.is_loading,
        rows: 4,
        placeholder: "Комментарий",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
      }, null, 8, ["disabled", "value"])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}